"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateValidator = void 0;
var dateValidator = function (value) {
    return ((typeof value === "string" && !isNaN(Date.parse(value))) ||
        value instanceof Date);
};
exports.dateValidator = dateValidator;
//# sourceMappingURL=dateValidator.js.map